module.exports = __webpack_public_path__ + "img/allStar.941efae8.jpeg";